import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Impact sound insulation - Levels in the receiving room Li",
  description: "Averaged  levels in the receiving room with background noise for first source position are shown.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-10.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
